






































import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class RuleInfo extends Vue {
  get jinroGame() {
    if (this.$store.state.jinroGame) {
      return this.$store.state.jinroGame;
    }
    return {};
  }

  get murabitoNum(): number {
    if (this.jinroGame) {
      return this.jinroGame.murabitoNum;
    }
    return 0;
  }

  get jinroNum(): number {
    if (this.jinroGame) {
      return this.jinroGame.jinroNum;
    }
    return 0;
  }

  get kyojinNum(): number {
    if (this.jinroGame) {
      return this.jinroGame.kyojinNum;
    }
    return 0;
  }

  get reibaishiNum(): number {
    if (this.jinroGame) {
      return this.jinroGame.reibaishiNum;
    }
    return 0;
  }

  get uranaishiNum(): number {
    if (this.jinroGame) {
      return this.jinroGame.uranaishiNum;
    }
    return 0;
  }

  get karyudoNum(): number {
    if (this.jinroGame) {
      return this.jinroGame.karyudoNum;
    }
    return 0;
  }

  get playerNum(): number {
    if (this.jinroGame) {
      return this.jinroGame.playerNum;
    }
    return 0;
  }
}
